/**
 * Trang giữ chỗ dùng cho mọi tuyến của bộ định tuyến rỗng. Các đợt sau thay
 * từng tuyến bằng màn hình nghiệp vụ thật.
 */
import type { ReactNode } from 'react';
import { vi } from '../ngon-ngu/vi';

export function TrangCho({ tieuDe }: { tieuDe: string }): ReactNode {
  return (
    <section>
      <h1>{tieuDe}</h1>
      <p>{vi.noiDung.khungDangDung}</p>
    </section>
  );
}

export function TrangKhongTimThay(): ReactNode {
  return (
    <section>
      <h1>{vi.noiDung.khongTimThayTrang}</h1>
    </section>
  );
}
